export const apiName: string = 'obrigacoes';
export const obrigacoesRoute: string = 'obrigacoes';
export const obrigacoesStorage: string = 'obrigacoes';
export const obrigacoesModuleName: any = {plural: 'Obrigações', single: 'Obrigação'};



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/obrigacoes/shared/data.service.ts
 **/